import { fetchFeatureFlags } from '../../../api/fetchers/featureFlags/fetcher';
import type { FeatureConfigList } from '../types';

import type { FeatureServiceFetcher } from './types';

export class PMSFetcher implements FeatureServiceFetcher {
  constructor(
    private JSESSIONID: string,
    private baseUrl: string,
    private tableId?: string
  ) {}

  fetch(): Promise<FeatureConfigList> {
    return fetchFeatureFlags({
      url: this.baseUrl,
      JSESSIONID: this.JSESSIONID,
      tableId: this.tableId,
    }).then((response): FeatureConfigList => {
      Object.entries(response).forEach(([key, value]) => {
        if (value === 'true') {
          response[key] = true;
        } else if (value === 'false') {
          response[key] = false;
        }
      });
      return response;
    });
  }
}
